import { generate } from "rxjs"

export const ModuleSetupData = [
    // Academic Module
    {
        Index: 1,
        Module: 'Sections',
        ComponentImage: "assets/media/svg/bnspur-module-tour/section.svg",
        ComponentDetailTitle: "Sections",
        ComponentDescription: "Students of each grade are divided into different classes, and this module aims to divide the students and administer them into different sections.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "Manage Sections",
            CardDescription: "With the help of this module, you can manage to create, modify and remove any particular section, according to your requirement. There is no limit to adding the number of students in a particular section.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Import",
            CardDescription: "This feature helps you to import a bunch of data at a time, without going through the time-consuming procedure of entering the data one by one.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Delete",
            CardDescription: "If you want to delete the data you have entered in this module, you can easily delete it at once by selecting all the data you desire to remove.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 2,
        Module: 'Subjects',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/subject.svg",
        ComponentDetailTitle: "Subjects",
        ComponentDescription: "Acknowledging the different subjects in mind, we have created this module to ease your work. This module allows students and teachers to access various subjects offered in the specific grades.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "Manage Subjects",
            CardDescription: "This module allows you to add, edit and delete any subjects you want, as your requirement enables you. We have put no limit on the number of subjects you can add in this particular module.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Import",
            CardDescription: "This feature helps you to import a bunch of data at a time, without going through the time-consuming procedure of entering the data one by one.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Delete",
            CardDescription: "If you want to delete the data you have entered in this module, you can easily delete it at once by selecting all the data you desire to remove.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 3,
        Module: 'Classes',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/class.svg",
        ComponentDetailTitle: "Classes",
        ComponentDescription: "This module will assist you in setting the timetable of the classes, not just for a particular grade or section, but you can easily enter the information of all the classes and that can be accessed by both teachers as well as the students.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "Manage Subjects",
            CardDescription: "Using this module, you can create, update and delete the timetable as per the circumstances. It simplifies the process as you can cross-check the entered data and do not make any mistakes of keeping the class of the same teacher into two or more classes. ",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Import",
            CardDescription: "This feature helps you to import a bunch of data at a time, without going through the time-consuming procedure of entering the data one by one.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Delete",
            CardDescription: "If you want to delete the data you have entered in this module, you can easily delete it at once by selecting all the data you desire to remove.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 4,
        Module: 'Syllabus',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/syllabus.svg",
        ComponentDetailTitle: "Syllabus",
        ComponentDescription: "In this module, teachers can upload syllabus of different subjects. Students can visit this module and access the syllabus of all the subjects posted by the teachers on this module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "Manage syllabus",
            CardDescription: "Teachers can add or remove the sections of the syllabus, and can also make changes once they have posted the syllabus. This helps students to remain up-to-date regarding the syllabus for their exams.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Bulk Import",
            CardDescription: "This feature helps you to import a bunch of data at a time, without going through the time-consuming procedure of entering the data one by one.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 5,
        Module: 'Study Material',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/study-material.svg",
        ComponentDetailTitle: "Study Materials",
        ComponentDescription: "Utilizing this module, the teachers of different subjects can post the study materials in the form of .doc or .pdf. Students can visit this module and access all the materials that have been posted on the module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: " Upload the study material",
            CardDescription: "This helps assist the teachers to post the study material on the module, and help students to acquire the material. This module has simplified the process of obtaining study materials.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Manage the material",
            CardDescription: "Once the study material has been uploaded, the teacher can totally modify the material posted into a particular section, under the specific title, by adding more or deleting the existing material.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }
    , {
        Index: 6,
        Module: 'Assignments',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/assignment.svg",
        ComponentDetailTitle: "Assignments",
        ComponentDescription: "This is the module where teachers can post the assignments for the students to complete it, and also set the deadline for the same. Teachers can also evaluate the assignment and provide the feedback in the same module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "New Assignment",
            CardDescription: "This feature allows the teacher to create a new assignment with a due date. ",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Edit assignment",
            CardDescription: "If the teacher wants to modify the assignment details after posting it, this feature will enable them to modify the same.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "View Submissions",
            CardDescription: "Once the students have posted the assignment, only the teacher can view them, evaluate them and post feedback.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 7,
        Module: 'Grades',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/grade.svg",
        ComponentDetailTitle: "Grades",
        ComponentDescription: "In this module, the concerned faculty can post the grades under the title of a particular exam. On clicking that title, one can view the results of that exam.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "Manage Grade Set",
            CardDescription: "A teacher can add, edit or delete the particular grade set in this section.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Grade Range",
            CardDescription: "With this feature, teachers can set the grade range according to the percentage.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 8,
        Module: 'Exams',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/exam.svg",
        ComponentDetailTitle: "Exams",
        ComponentDescription: "With this module, teachers can easily schedule the examination, online or offline. The students can visit this module to appear for any examinations.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "New Exam",
            CardDescription: "The teacher can add a new exam with the details like its date and time, title of the exam, the subject and the total marks of the exam.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Edit Exam",
            CardDescription: "In case of any changes in the details of examination after scheduling an exam, the teacher can edit it.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Export to Excel",
            CardDescription: "The data you have entered in this module, you can directly get the hold on that data into an excel sheet.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Exam Bulk Import",
            CardDescription: "This feature helps you to import a bunch of data at a time, without going through the time-consuming procedure of entering the data one by one.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Redirect to the Exam Paper",
            CardDescription: "In case of online examination, this button will lead the students directly to the exam paper where they can appear for the exam.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 9,
        Module: 'Marks',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/mark.svg",
        ComponentDetailTitle: "Marks",
        ComponentDescription: "In this module, teachers can upload marks of specific exams and for the specific students.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "Insert Marks",
            CardDescription: "With the use of the ‘check paper’ button, the teachers can evaluate the paper of the student and put marks.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 10,
        Module: 'Results',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/result-list.svg",
        ComponentDetailTitle: "Results",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    // Users Module
    {
        Index: 11,
        Module: 'Principals',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/principal.svg",
        ComponentDetailTitle: "Principals",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 12,
        Module: 'Admin And Management',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/admin-and-management.svg",
        ComponentDetailTitle: "Admins",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 13,
        Module: 'Faculties',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/faculty.svg",
        ComponentDetailTitle: "Faculties",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 14,
        Module: 'Students',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/student.svg",
        ComponentDetailTitle: "Students",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 15,
        Module: 'Drivers',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/driver.svg",
        ComponentDetailTitle: "Drivers",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 16,
        Module: 'Agents',
        IsTourDone: false,
        ComponentImage: "assets/media/svg/bnspur-module-tour/agent.svg",
        ComponentDetailTitle: "Agents",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },

    // Inventory Module
    {
        Index: 17,
        Module: 'Store Categories',
        ComponentImage: "assets/media/svg/bnspur-module-tour/store-categories.svg",
        ComponentDetailTitle: "Store Categories",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 18,
        Module: 'Store Types',
        ComponentImage: "assets/media/svg/bnspur-module-tour/store-types.svg",
        ComponentDetailTitle: "Store Types",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 19,
        Module: 'Stores',
        ComponentImage: "assets/media/svg/bnspur-module-tour/stores.svg",
        ComponentDetailTitle: "Stores",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 20,
        Module: 'Item Categories',
        ComponentImage: "assets/media/svg/bnspur-module-tour/item-categories.svg",
        ComponentDetailTitle: "Item Categories",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 21,
        Module: 'Store Items',
        ComponentImage: "assets/media/svg/bnspur-module-tour/store-items.svg",
        ComponentDetailTitle: "Store Items",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 22,
        Module: 'Supplier Type',
        ComponentImage: "assets/media/svg/bnspur-module-tour/supplier-type.svg",
        ComponentDetailTitle: "Supplier Type",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 23,
        Module: 'Suppliers',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Suppliers",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 24,
        Module: 'Item Requests',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Item Requests",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 25,
        Module: 'Purchase Orders',
        ComponentImage: "assets/media/svg/bnspur-module-tour/purchase-order.svg",
        ComponentDetailTitle: "Purchase Orders",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 26,
        Module: 'GRN',
        ComponentImage: "assets/media/svg/bnspur-module-tour/GRN.svg",
        ComponentDetailTitle: "GRN",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 27,
        Module: 'Billing and invoices',
        ComponentImage: "assets/media/svg/bnspur-module-tour/billing.svg",
        ComponentDetailTitle: "Billing and invoices",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },

    // Activities Module
    {
        Index: 28,
        Module: 'Functions',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Functions",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 29,
        Module: 'Seminar and Workshop',
        ComponentImage: "assets/media/svg/bnspur-module-tour/seminar-and-workshop.svg",
        ComponentDetailTitle: "Seminar and Workshop",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    },
    {
        Index: 30,
        Module: 'Observations',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Observations",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 31,
        Module: 'PTMs',
        ComponentImage: "assets/media/svg/bnspur-module-tour/parent-teacher-meeting.svg",
        ComponentDetailTitle: "PTMs",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }
    // Task Management module
    , {
        Index: 32,
        Module: 'Task',
        ComponentImage: "assets/media/svg/bnspur-module-tour/task-management.svg",
        ComponentDetailTitle: "Task",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 33,
        Module: 'Assigned Task',
        ComponentImage: "assets/media/svg/bnspur-module-tour/task-assign.svg",
        ComponentDetailTitle: "Assigned Task",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    // Others Module
    , {
        Index: 34,
        Module: 'Complaints',
        ComponentImage: "assets/media/svg/bnspur-module-tour/complaint.svg",
        ComponentDetailTitle: "Complaints",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }
    , {
        Index: 35,
        Module: 'Notes',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Notes",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }
    , {
        Index: 36,
        Module: 'Hostels',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Hostels",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    //  Mail Module
    , {
        Index: 37,
        Module: 'Mail',
        ComponentImage: "assets/media/svg/bnspur-module-tour/mail.svg",
        ComponentDetailTitle: "Mail",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    // Library Module
    , {
        Index: 38,
        Module: 'Books',
        ComponentImage: "assets/media/svg/bnspur-module-tour/books.svg",
        ComponentDetailTitle: "Books",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 39,
        Module: 'Book Issue',
        ComponentImage: "assets/media/svg/bnspur-module-tour/book-issue.svg",
        ComponentDetailTitle: "Book Issue",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    // Attendance Module
    , {
        Index: 40,
        Module: 'Manual Attendance',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Manual Attendance",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 41,
        Module: 'Beacon Attendance',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Beacon Attendance",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 42,
        Module: 'My Leaves',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "My Leaves",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 43,
        Module: 'Leave To Approve',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Leave To Approve",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }, {
        Index: 44,
        Module: 'Holiday',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Holiday",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    // Content Management Module
    , {
        Index: 45,
        Module: 'Content Management',
        ComponentImage: "assets/media/svg/bnspur-module-tour/content-management.svg",
        ComponentDetailTitle: "Content Management",
        ComponentDescription: "Build a custom, branded payment page for your business in under 10 minutes and start accepting international and domestic payments with zero integration and tech efforts.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: [{
            CardTitle: "No Coding Required",
            CardDescription: "Your business can go online with zero integration and tech efforts. We build and operate for you.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Custom Branded Page",
            CardDescription: "Customize the look and feel of your payment pages to reflect your brand colours, for seamless customer experience.",
            CardImage: "assets/media/project-logos/6.png"
        }, {
            CardTitle: "Payment Button",
            CardDescription: "Design a customized payment button which can be used on your site/app to trigger the payment page.",
            CardImage: "assets/media/project-logos/6.png"
        }]
    }

    // Recruitment Module
    , {
        Index: 46,
        Module: 'Admission Tests',
        ComponentImage: "assets/media/svg/bnspur-module-tour/admission-test.svg",
        ComponentDetailTitle: "Admission Tests",
        ComponentDescription: "A test for admission can be created, edited and deleted in this module. For the students who wish to take admission in this school can appear for the test from here.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 47,
        Module: 'Vacancy',
        ComponentImage: "assets/media/svg/bnspur-module-tour/vacancy.svg",
        ComponentDetailTitle: "Vacancy",
        ComponentDescription: "For any vacant position along with the number of vacancies, the details will be posted in this module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 48,
        Module: 'Admission Inquiries',
        ComponentImage: "assets/media/svg/bnspur-module-tour/admission-inquiries.svg",
        ComponentDetailTitle: "Admission Inquiries",
        ComponentDescription: "For any student who wishes to apply for admission in this school, they can visit this module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 49,
        Module: 'Staff Applications',
        ComponentImage: "assets/media/svg/illustrations/login-visual-bnspur.svg",
        ComponentDetailTitle: "Staff Applications",
        ComponentDescription: "When applied for a vacant position, the status and reviews of their recruitment position can be viewed in this module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 50,
        Module: 'Test Marks',
        ComponentImage: "assets/media/svg/bnspur-module-tour/test-marks.svg",
        ComponentDetailTitle: "Test Marks",
        ComponentDescription: "When a candidate has applied for the admission test, they can view the result of the same tests in this part of the module.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 51,
        Module: 'Result Configurations',
        ComponentImage: "assets/media/svg/bnspur-module-tour/result-config.svg",
        ComponentDetailTitle: "Result Configurations",
        ComponentDescription: "This feature will allow you to configure the results.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 52,
        Module: 'Generate Result',
        ComponentImage: "assets/media/svg/bnspur-module-tour/result-generate.svg",
        ComponentDetailTitle: "Generate Result",
        ComponentDescription: "To generate results, a teacher can fill up the details like class, section, announcement date and result configuration.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 53,
        Module: 'Result Lists',
        ComponentImage: "assets/media/svg/bnspur-module-tour/result-list.svg",
        ComponentDetailTitle: "Result Lists",
        ComponentDescription: "Here will be the list of results according to the classes and the sections and they will be uploaded by the teachers and accessed by the students.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 54,
        Module: 'Move students',
        ComponentImage: "assets/media/svg/bnspur-module-tour/move-student.svg",
        ComponentDetailTitle: "Move students",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }

    // Time Table
    , {
        Index: 55,
        Module: 'Timing Set',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Timing Sets",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 56,
        Module: 'Timeset Allocation',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timeset.svg",
        ComponentDetailTitle: "Timeset Allocation",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 57,
        Module: 'Timetable',
        ComponentImage: "assets/media/svg/bnspur-module-tour/time-table.svg",
        ComponentDetailTitle: "Timetables",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 58,
        Module: 'Manage Feedbacks',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Manage Feedbacks",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 59,
        Module: 'Fill Feedbacks',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Fill Feedbacks",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }, {
        Index: 60,
        Module: 'Manage Opinion Polls',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Manage Opinion Polls",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 61,
        Module: 'Answer Opinion Polls',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Answer Opinion Polls",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 62,
        Module: 'Visitor Logs',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Visitor Logs",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 63,
        Module: 'Daily Expenses',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Daily Expenses",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 64,
        Module: 'Generate Id Card',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Generate Id Card",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 65,
        Module: 'Id card',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Id card",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 66,
        Module: 'Addition-Deduction',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Addition-Deduction",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 67,
        Module: 'Generate Payslip',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Generate Payslip",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 68,
        Module: 'Payslips',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Payslips",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
    , {
        Index: 69,
        Module: 'Co-Curricular Events',
        ComponentImage: "assets/media/svg/bnspur-module-tour/timing-set.svg",
        ComponentDetailTitle: "Co-Curricular Events",
        ComponentDescription: "This feature will allow you to move a student from one section or class to another. You just have to select the students you want to move, click on the ‘move students’ button and select the section or class where you want to move them.",
        ComponentFeatureTitle: "What makes Payment Pages great?",
        IsTourDone: false,
        ComponentFeaturesCard: []
    }
]
